/* ==========================================================================
   Skinetic Labs — theme.js
   Vanilla JS. Cart drawer + AJAX, free-shipping bar, rails, reveal, header,
   mobile menu, popup, privacy consent, analytics. Deferred (see theme.liquid).
   ========================================================================== */
(function () {
  'use strict';
  var CFG = window.SkineticConfig || {};
  var THRESHOLD = CFG.freeShippingThreshold || 5000;
  var ROUTES = CFG.routes || { cart_add: '/cart/add.js', cart_change: '/cart/change.js', cart_js: '/cart.js', cart: '/cart' };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '£{{amount}}';
    var amount = (cents / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------- analytics ---------- */
  function track(event, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, payload || {}));
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#ToastNotice');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- header on scroll ---------- */
  var header = $('[data-header]');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 40);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- mobile menu ---------- */
  var mobileMenu = $('[data-mobile-menu]');
  function setMobile(open) {
    if (!mobileMenu) return;
    mobileMenu.classList.toggle('is-open', open);
    mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-open]')) setMobile(true);
    if (e.target.closest('[data-mobile-close]')) setMobile(false);
  });

  /* ---------- announcement dismiss ---------- */
  var ann = $('[data-announcement]');
  if (ann) {
    if (localStorage.getItem('skl_ann_dismissed') === '1') ann.style.display = 'none';
    var annClose = $('[data-announcement-close]', ann);
    if (annClose) annClose.addEventListener('click', function () {
      ann.style.display = 'none';
      localStorage.setItem('skl_ann_dismissed', '1');
    });
  }

  /* ==========================================================================
     CART DRAWER
     ========================================================================== */
  var drawer = $('[data-cart-drawer]');
  var overlay = $('[data-drawer-overlay]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) { window.location.href = ROUTES.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = $('[data-drawer-close]', drawer);
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); setMobile(false); closePopup(); }
  });

  /* ---------- cart state ---------- */
  function getCart() {
    return fetch(ROUTES.cart_js, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function lineItemHTML(item) {
    var img = (item.image || '').replace(/(\.\w+)(\?|$)/, '$1');
    var meta = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="line-item__meta">' + item.variant_title + '</div>' : '';
    return '' +
      '<div class="line-item" data-line-item data-line-key="' + item.key + '">' +
        '<a href="' + item.url + '"><img src="' + img + '&width=160" alt="" width="64" height="80"></a>' +
        '<div>' +
          '<a href="' + item.url + '"><div class="line-item__title">' + (item.product_title || item.title).toLowerCase() + '</div></a>' +
          meta +
          '<div class="qty" style="margin-top:.5rem;">' +
            '<button type="button" data-qty-minus aria-label="decrease">−</button>' +
            '<input class="line-qty" type="number" min="0" value="' + item.quantity + '" data-line-qty aria-label="quantity">' +
            '<button type="button" data-qty-plus aria-label="increase">+</button>' +
          '</div>' +
          '<button type="button" class="line-item__remove" data-line-remove>remove</button>' +
        '</div>' +
        '<div class="line-item__price">' + formatMoney(item.final_line_price || item.line_price) + '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    if (!cart) return;
    var count = $('[data-cart-count]');
    if (count) { count.textContent = cart.item_count; count.hidden = false; }
    var itemsWrap = $('[data-cart-items]');
    var emptyWrap = $('[data-cart-empty]');
    var foot = $('[data-drawer-foot]');
    if (itemsWrap) itemsWrap.innerHTML = cart.items.map(lineItemHTML).join('');
    if (cart.item_count > 0) {
      if (emptyWrap) emptyWrap.style.display = 'none';
      if (foot) foot.hidden = false;
      if (!itemsWrap && drawer) {
        var body = $('[data-drawer-body]', drawer);
        if (body && !$('[data-cart-items]', body)) {
          var bar = $('[data-shipping-bar]', body);
          var html = '<div data-cart-items>' + cart.items.map(lineItemHTML).join('') + '</div>';
          if (bar) bar.insertAdjacentHTML('afterend', html);
        }
      }
    } else {
      if (foot) foot.hidden = true;
    }
    var sub = $('[data-cart-subtotal]');
    if (sub) sub.textContent = formatMoney(cart.total_price);
    updateShippingBar(cart.total_price);
  }

  /* ---------- free shipping bar ---------- */
  function updateShippingBar(total) {
    $$('[data-shipping-bar]').forEach(function (bar) {
      var msg = $('[data-shipping-msg]', bar);
      var fill = $('[data-shipping-fill]', bar);
      var remaining = THRESHOLD - total;
      var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        msg.innerHTML = remaining > 0
          ? "you're <strong>" + formatMoney(remaining) + "</strong> away from <strong>free shipping</strong>"
          : "<strong>you've unlocked free shipping ✦</strong>";
      }
    });
  }

  /* ---------- add to cart ---------- */
  function addToCart(variantId, qty, props, btn) {
    var body = { items: [{ id: Number(variantId), quantity: qty || 1 }] };
    if (props) body.items[0].properties = props;
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'adding…'; }
    return fetch(ROUTES.cart_add, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (data) { throw new Error(data.description || "Unable to add product"); });
      return r.json();
    })
      .then(function () { return getCart(); })
      .then(function (cart) {
        renderCart(cart);
        openDrawer();
        toast('added to your ritual');
        track('add_to_cart', { ecommerce: { currency: 'GBP', items: [{ item_id: variantId, quantity: qty || 1 }] } });
        return cart;
      })
      .catch(function () { toast('We could not add that item. Please try again.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add To Ritual'; } });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('.quick-add');
    if (add && add.dataset.variantId) {
      e.preventDefault();
      addToCart(add.dataset.variantId, 1, null, add);
    }
  });

  /* ---------- change quantity / remove ---------- */
  function changeLine(key, qty) {
    return fetch(ROUTES.cart_change, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var li = e.target.closest('[data-line-item]');
    if (!li) return;
    var key = li.dataset.lineKey;
    var input = $('[data-line-qty]', li);
    if (e.target.closest('[data-line-remove]')) { changeLine(key, 0); }
    else if (e.target.closest('[data-qty-plus]')) { changeLine(key, parseInt(input.value, 10) + 1); }
    else if (e.target.closest('[data-qty-minus]')) { changeLine(key, Math.max(0, parseInt(input.value, 10) - 1)); }
  });
  document.addEventListener('change', function (e) {
    var li = e.target.closest('[data-line-item]');
    if (li && e.target.matches('[data-line-qty]')) changeLine(li.dataset.lineKey, Math.max(0, parseInt(e.target.value, 10) || 0));
  });

  /* ==========================================================================
     RAILS (horizontal scroll)
     ========================================================================== */
  $$('.rail').forEach(function (rail) {
    var vp = $('[data-rail]', rail);
    var prev = $('[data-rail-prev]', rail);
    var next = $('[data-rail-next]', rail);
    if (!vp) return;
    function step() { return vp.querySelector('*') ? vp.querySelector('*').offsetWidth + 20 : 300; }
    if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { vp.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  });

  /* ==========================================================================
     REVEAL ON SCROLL
     ========================================================================== */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ==========================================================================
     NEWSLETTER POPUP
     ========================================================================== */
  var popup = $('[data-popup]');
  function closePopup() {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
  }
  if (popup) {
    var seen = localStorage.getItem('skl_popup_seen');
    var capped = seen && (Date.now() - parseInt(seen, 10)) < 1000 * 60 * 60 * 24 * 7;
    if (!capped) {
      var delay = (parseInt(popup.dataset.delay, 10) || 6) * 1000;
      setTimeout(function () {
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        localStorage.setItem('skl_popup_seen', String(Date.now()));
      }, delay);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]') || e.target === popup) closePopup();
    });
  }

  /* ==========================================================================
     COOKIE CONSENT
     ========================================================================== */
  var consentBanner = $('[data-cookie-consent]');
  if (consentBanner) {
    var privacyApi = null;
    var consentInputs = $$('[data-cookie-preference]', consentBanner);
    var consentActions = $$('[data-cookie-consent-save], [data-cookie-consent-accept], [data-cookie-consent-reject], [data-cookie-consent-close]', consentBanner);
    var designMode = consentBanner.dataset.designMode === 'true';

    function showConsentBanner() {
      consentBanner.hidden = false;
      consentBanner.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(function () { consentBanner.classList.add('is-visible'); });
    }

    function hideConsentBanner() {
      consentBanner.classList.remove('is-visible');
      consentBanner.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () { consentBanner.hidden = true; }, 240);
    }

    function setConsentBusy(busy) {
      consentActions.forEach(function (button) { button.disabled = busy; });
    }

    function consentChoices(value) {
      return { analytics: value, marketing: value, preferences: value };
    }

    function selectedConsentChoices() {
      var choices = consentChoices(false);
      consentInputs.forEach(function (input) { choices[input.dataset.cookiePreference] = input.checked; });
      return choices;
    }

    function syncConsentChoices(consent) {
      consentInputs.forEach(function (input) {
        input.checked = consent[input.dataset.cookiePreference] === 'yes';
      });
    }

    function recordConsent(choices) {
      if (!privacyApi) {
        hideConsentBanner();
        return;
      }
      setConsentBusy(true);
      privacyApi.setTrackingConsent(choices, function () {
        setConsentBusy(false);
        hideConsentBanner();
      });
    }

    function initialisePrivacy(attempt) {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        if (attempt < 20) window.setTimeout(function () { initialisePrivacy(attempt + 1); }, 150);
        else if (designMode) showConsentBanner();
        return;
      }

      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error || !window.Shopify.customerPrivacy) {
          if (designMode) showConsentBanner();
          return;
        }
        privacyApi = window.Shopify.customerPrivacy;
        syncConsentChoices(privacyApi.currentVisitorConsent());
        if (privacyApi.shouldShowBanner() || designMode) showConsentBanner();
      });
    }

    var saveConsent = $('[data-cookie-consent-save]', consentBanner);
    var acceptConsent = $('[data-cookie-consent-accept]', consentBanner);
    var rejectConsent = $('[data-cookie-consent-reject]', consentBanner);
    var closeConsent = $('[data-cookie-consent-close]', consentBanner);
    var openConsent = $$('[data-cookie-consent-open]');

    if (saveConsent) saveConsent.addEventListener('click', function () { recordConsent(selectedConsentChoices()); });
    if (acceptConsent) acceptConsent.addEventListener('click', function () { recordConsent(consentChoices(true)); });
    if (rejectConsent) rejectConsent.addEventListener('click', function () { recordConsent(consentChoices(false)); });
    if (closeConsent) closeConsent.addEventListener('click', function () { recordConsent(consentChoices(false)); });
    openConsent.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        if (privacyApi) syncConsentChoices(privacyApi.currentVisitorConsent());
        showConsentBanner();
      });
    });

    initialisePrivacy(0);
  }

  /* ---------- newsletter signup analytics ---------- */
  $$('[data-analytics="newsletter_signup"]').forEach(function (form) {
    var f = form.closest('form') || form;
    f.addEventListener('submit', function () { track('newsletter_signup', {}); });
  });

  /* ---------- begin_checkout ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-checkout]')) track('begin_checkout', {});
  });

  /* ==========================================================================
     COLLECTION: client-side sort (progressive enhancement)
     ========================================================================== */
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var grid = document.querySelector('[data-product-grid]');
      if (!grid) return;
      var items = $$('[data-product-item]', grid);
      var by = sel.value;
      items.sort(function (a, b) {
        if (by === 'price-ascending') return (+a.dataset.price) - (+b.dataset.price);
        if (by === 'price-descending') return (+b.dataset.price) - (+a.dataset.price);
        if (by === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title);
        if (by === 'title-descending') return b.dataset.title.localeCompare(a.dataset.title);
        return 0;
      });
      items.forEach(function (el) { grid.appendChild(el); });
      track('view_item_list', { sort: by });
    });
  });

  /* expose for ritual.js (PDP) */
  window.SkineticAddToCart = addToCart;
  window.SkineticOpenDrawer = openDrawer;

  /* sync cart on load (keeps count/bar accurate) */
  getCart().then(renderCart);
})();
